import { render, staticRenderFns } from "./ImagesTab.htm?vue&type=template&id=01a807c2&scoped=true&"
import script from "./ImagesTab.ts?vue&type=script&lang=js&"
export * from "./ImagesTab.ts?vue&type=script&lang=js&"
import style0 from "./ImagesTab.scss?vue&type=style&index=0&id=01a807c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a807c2",
  null
  
)

export default component.exports